import { render, staticRenderFns } from "./CompanyEditEmails.vue?vue&type=template&id=33379f68&scoped=true&"
import script from "./CompanyEditEmails.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditEmails.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyEditEmails.vue?vue&type=style&index=0&id=33379f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33379f68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33379f68')) {
      api.createRecord('33379f68', component.options)
    } else {
      api.reload('33379f68', component.options)
    }
    module.hot.accept("./CompanyEditEmails.vue?vue&type=template&id=33379f68&scoped=true&", function () {
      api.rerender('33379f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditEmails.vue"
export default component.exports